/*
 interface SearchObject {
 baseBulkSize: number;
 nextBulkSize: number;

 query: string;
 facets: any[];
 pcAvailability: boolean;
 scope: any;
 sortBy: string;


 searchInProgress: boolean;
 }

 interface SearchStateService{
 currentItem: any;
 resultObject: any;
 searchObject: any;
 selectedItem: any;
 getItemAtIndex: any;
 hasNextBulk: any;
 isNotFirstBulk: any;
 nextBulk: any;
 previousBulk: any;
 getResultObject: any;
 getSearchObject: any;
 setSearchObject: any;
 setResultObject: any;
 updateSearchObject: any;
 selectItem: any;
 getSelectedItem: any;
 addImagesToResultObject: any;
 isSearchInProgress: any;
 setSearchInProgress: any;
 selectedDetail?: any;
 }
 */

import {getDefaultScope} from '../appConfig/appConfigForward';
import {getResultsBulkSize, getShowMoreThreshold} from '../appConfig/appConfigForward';

import {Injectable, Inject} from 'ng-metadata/core';
import {JsonUtils} from '../nddUtils/jsonUtils.service';
import IPromise = angular.IPromise;
import {PrimoResponse} from '../infra/dataStructures/PrimoResponses/doc.interfcae';
import {ResultUtil} from "../nddUtils/resultUtil.service";

const angular: angular.IAngularStatic = require('angular');

interface IFacet {
    displayedType: string;
    facetType: string;
    label: string;
    name: string;
    type: string;
    isMultiFacet: boolean;
    multiFacetGroupId: string;
    checked: boolean;
    value: string;
    tooltip: string;
    translationsPromise: IPromise<IFacet>;
}

export interface ISearchObject {
    noConVoc?: boolean;
    newSearch: boolean;
    offset: number;
    to: number;
    bulkSize: number;
    facets: IFacet[];
    mode: string;
    pcAvailability: boolean;
    searchInFulltextUserSelection: boolean;
    query: string;
    scope: string;
    browseParams: string;
    searchInProgress: boolean;
    skipDelivery: string;
    isCDSearch : boolean;
    sortby: string;
    explain: string;
    otbRanking: boolean;
    searchCDI: string;
    rapido: string;
    tab: string;
    journals: string;
    databases: string;
    featuredNewspapersIssnList: string;
    fromDate: string;
    getMore: number;
    metalibMoreStatus: {};
    isRelatedItems: false;
    organization: string
    citationTrailFilterByAvailability: boolean;
    originatingSystemId?: string;
    originatingSystem?: string;
    isRAsearch?: boolean;
}

interface IResultInfoObject {
    total: number;
    last?: string;
    maxTotal?: number;
    errorDetails?: string;
    hasMoreResults?: boolean;
    isAuthority?: boolean;
}

class ResultObject {
    public info: IResultInfoObject;
    public data = [];


    private featuredResult: {};
    private didUMean: string;
    private details: {};
    public facets: {};
    private images: {};
    public beaconO22: {}; // server response time
    public expandedSearchAfterZeroResults: string;
    public lang3: string;

    public saveResponse(res) {
        this.featuredResult = res.featuredResult;
        this.data = res.groups;
        this.didUMean = res.did_u_mean;
        this.details = res.details;
        this.info = res.info;
        this.facets = res.facetsList;
        this.images = res.images;
        this.beaconO22 = res.beaconO22;
        this.lang3 = res.lang3;
        this.expandedSearchAfterZeroResults = res.expandedSearchAfterZeroResults;
        if (res && res.info) {
            res.info.isAuthority ? this.data = res.docs : false;
        }
    }

    public updateResponse(res, replaceResults = false) {
        if (replaceResults) {
            this.data = res.groups;
            this.featuredResult = res.featuredResult;
        } else {
            Array.prototype.push.apply(this.data, res.groups);
        }
        this.info = res.info;
        this.facets = res.facetsList;
        this.beaconO22 = res.beaconO22;
    }

    public updateResponseImages(images) {

        this.images = images;
    }

}


@Injectable()
export class SearchStateService {
    private resultsBulkSize = this.resultUtil.updatedBulkSize;
    private showMoreThreshold = getShowMoreThreshold();

    /* private members */
    private currentItem: Object;
    private resultObject: ResultObject = new ResultObject();
    private searchObject: ISearchObject;
    private selectedItem: Object;
    private tempTopMaxItems: PrimoResponse.IDoc[] = [];

    private firstBulk = 0;
    private selectedDetail;
    private PAGE_SIZE;
    private lastViewedOffset: number = 0;
    private offsetLimitNotificationVisible: boolean = false;
    private offsetLimitNotificationVisibleAfterSearch: boolean = false;

    constructor(private jsonUtils: JsonUtils,
                private resultUtil: ResultUtil,
                @Inject('$filter') private $filter: ng.IFilterService,
                @Inject('$anchorScroll') private $anchorScroll: ng.IAnchorScrollService) {
        this.$filter = $filter;

        /* private members */
        this.currentItem = {};
        this.selectedItem = '';
    }

    get pageSize() {
        return this.resultUtil.updatedBulkSize;
    }

    resetResultObject() {
        this.resultObject = new ResultObject();
    }

    public resetSearchObject() {
        this.offsetLimitNotificationVisible = this.offsetLimitNotificationVisibleAfterSearch;
        this.offsetLimitNotificationVisibleAfterSearch = false;
        this.searchObject = {} as ISearchObject;
    }

    public getItemAtIndex(index) {
        let data = this.resultObject.data;
        if (data && data.length > index) {
            return data[index];
        } else {
            return null;
        }
    }

    public hasNextBulk() {
        const info = this.resultObject.info;
        if (!info) {
			return false;
		}
        if (info.hasMoreResults) {
            return true;
        }
        let total = (info.maxTotal > 0) ? info.maxTotal : info.total;
        return (this.searchObject.to < total);
    }

    public hasPreviosBulk() {
        return this.isNotFirstBulk();
    }

    public isNotFirstBulk() {
        return this.searchObject.offset > this.firstBulk;
    }

    public nextBulk() {
        //Change 'offset' to current offset plus bulk size
        //e.g. if bulk size is 5 and offset is 20, list is up to 20 + 5 = 25, so we want to get records offset 25
        //notice that in case of the rest records is less than the bulk size, the right amount of records will be gotten
        //e.g. offset is 20, bulk size is 5 but the list size is only 23, only 3 records will be gotten
        this.searchObject.offset = Math.min(
            this.searchObject.offset + this.searchObject.bulkSize, this.resultObject.info.total);
        //Update 'to'
        //This field is only for calculate the has next bulk and not used in the query
        this.searchObject.to = Math.min(
            this.searchObject.offset + this.searchObject.bulkSize, this.resultObject.info.total);
    }

    public jumpToPage(page) {
        this.searchObject.offset = Math.min(
            page * 10, this.resultObject.info.total);
        //On next bulk, change the bulk size (reduce it)
        //Update 'to'
        //This field is only for calculate the has next bulk and not used in the query
        this.searchObject.to = Math.min(
            this.searchObject.offset + this.searchObject.bulkSize, this.resultObject.info.total);
        this.searchObject.newSearch = true;
    }

    public previousBulk() {
        this.searchObject.offset = Math.max(this.searchObject.offset - this.searchObject.bulkSize, 0);
        let to = this.searchObject.offset + this.searchObject.bulkSize - 1;
        this.searchObject.to = Math.min(to, this.resultObject.info.total);
    }

    public getResultObject() {
        return this.resultObject;
    }

    public get numOfLoadedResultBulks(): number {
        if (!this.resultObject || !this.resultObject.data) {
            return 0;
        }
        return Math.ceil(this.resultObject.data.length / this.pageSize);
    }

    public getSearchObject(): ISearchObject {
        //removing the || {} caused issue PRM-33119
        return this.searchObject || ({} as ISearchObject);
    }

    public setUpdatedSearchObject(args) {
        this.searchObject = {
            bulkSize: this.pageSize,
            query: args.query || this.searchObject.query,
            facets: args.facets || this.searchObject.facets,
            pcAvailability: args.pcAvailability || this.searchObject.pcAvailability,
            searchInFulltextUserSelection: args.searchInFulltextUserSelection || this.searchObject.searchInFulltextUserSelection,
            scope: args.scope || this.searchObject.scope,
            browseParams: this.searchObject.browseParams,
            tab: args.tab || this.searchObject.tab,
            explain: args.explain || this.searchObject.explain,
            otbRanking: args.otbRanking || this.searchObject.otbRanking,
            searchCDI: args.searchCDI || this.searchObject.searchCDI,
            savedSearchId: args.savedSearchId || this.searchObject.savedSearchId,
            oSSKey: args.oSSKey || this.searchObject.oSSKey,
            rapido: args.rapido || this.searchObject.rapido,
            sortby: args.sortby || this.searchObject.sortby,
            journals: args.journals || this.searchObject.journals,
            databases: args.databases || this.searchObject.databases,
            featuredNewspapersIssnList: args.featuredNewspapersIssnList || this.searchObject.featuredNewspapersIssnList,
            fromDate: args.fromDate || this.searchObject.fromDate,
            offset: this.firstBulk,
            to: this.pageSize,
            newSearch: true,
            searchInProgress: false,
            mode: this.searchObject.mode,
            getMore: args.getMore,
            isRelatedItems: args.isRelatedItems,
            citationTrailFilterByAvailability: args.citationTrailFilterByAvailability || this.searchObject.citationTrailFilterByAvailability,
            isRAsearch: args.isRAsearch || this.searchObject.isRAsearch
        };
    }

    public setSearchObject(args, isAuthority?: boolean, offsetAuthority?: number) {
        if(isAuthority){
            this.searchObject = {
                bulkSize: this.pageSize,
                query: undefined,
                facets: undefined,
                pcAvailability: undefined,
                searchInFulltextUserSelection: undefined,
                scope: undefined,
                browseParams: undefined,
                tab: undefined,
                explain: undefined,
                otbRanking: undefined,
                searchCDI: undefined,
                savedSearchId: undefined,
                oSSKey: undefined,
                rapido: undefined,
                sortby: undefined,
                journals: undefined,
                databases: undefined,
                featuredNewspapersIssnList: undefined,
                fromDate: undefined,
                offset: offsetAuthority,
                to: this.pageSize,
                newSearch: true,
                searchInProgress: false,
                mode: undefined,
                getMore: undefined,
                isRelatedItems: undefined,
                citationTrailFilterByAvailability: undefined,
                isRAsearch: undefined
            };
        }
        else{
            if (args.searchObject) { //TODO
                args = args.searchObject;
            }
    
            let offset = args.offset || this.firstBulk;

            this.searchObject = {
                bulkSize: this.pageSize,
                query: args.query || '',
                facets: args.facets || [],
                pcAvailability: args.pcAvailability || false,
                searchInFulltextUserSelection: args.searchInFulltextUserSelection || false,
                scope: args.scope || getDefaultScope(),
                browseParams: args.browseParams,
                tab: args.tab,
                journals: args.journals,
                databases: args.databases,
                featuredNewspapersIssnList: args.featuredNewspapersIssnList,
                fromDate: args.fromDate,
                sortby: args.sortby,
                explain: args.explain,
                otbRanking: args.otbRanking || false,
                searchCDI: args.searchCDI,
                savedSearchId: args.savedSearchId,
                oSSKey: args.oSSKey,
                rapido: args.rapido,
                offset: offset,
                to: offset + this.pageSize,
                newSearch: true,
                searchInProgress: false,
                mode: args.mode,
                getMore: args.getMore,
                isRelatedItems: args.isRelatedItems,
                isIgnoreFacetSearch: args.isIgnoreFacetSearch,
                organization: args.organization,
                citationTrailFilterByAvailability: args.citationTrailFilterByAvailability,
                originatingSystem: args.originatingSystem,
                originatingSystemId: args.originatingSystemId,
                isRAsearch: args.isRAsearch
            };

            if (args['noConVoc']) {
                this.searchObject.noConVoc = true;
            }
        }   
    }

    public setResultObject(searchResponse, replaceResults = false) {

        if (this.searchObject.newSearch) {
            this.searchObject.newSearch = false;
            this.$anchorScroll();
            this.resultObject.saveResponse(searchResponse);
        } else {
            if (replaceResults) {
                this.$anchorScroll();
            }
            this.resultObject.updateResponse(searchResponse, replaceResults);
        }
        this.lastViewedOffset = this.searchObject.offset;
    }

    public setTempResultList(tempRes) {
        this.tempTopMaxItems = tempRes;
    }

    public getTempResultList() {
        return this.tempTopMaxItems;
    }

    public updateSearchObject(args) {
        angular.extend(this.searchObject, args);
    }

    public updateResultObject(args) {
        angular.extend(this.resultObject, args);
    }

    public selectItem(item) {
        this.selectedDetail = item;
    }

    public getSelectedItem() {
        return this.selectedDetail;
    }

    public addImagesToResultObject(searchResponse) {

        let imagesBarFillers = [];
        if (!angular.isUndefined(searchResponse.images)) {

            let imagesBarFillersArray = this.jsonUtils.convertObjectToArray(searchResponse.images);
            imagesBarFillersArray = this.$filter('filter')(imagesBarFillersArray, '!img/icon_image.png');
            for (let i = 0; i < imagesBarFillersArray.length && i < 9; i++) {
                imagesBarFillers.push({link: imagesBarFillersArray[i], type: 'dynamic'});
                //                    imagesBarFillers[i].link = imagesBarFillersArray[i];
                //                    imagesBarFillers[i].type = 'dynamic';
            }

            imagesBarFillers = imagesBarFillers.sort(function () {
                return 5 - Math.random();
            });
        }
        this.resultObject.updateResponseImages(imagesBarFillers);

    }

    public isSearchInProgress() {
        return (this.searchObject && this.searchObject.searchInProgress) || false;
    }

    public setSearchInProgress(value) {
        this.searchObject.searchInProgress = value;
    }

    public setSkipDelivery(value) {
        this.searchObject.skipDelivery = value;
    }

    public getSkipDelivery() {
        return this.searchObject.skipDelivery;
    }

    public setIsCDSearch(value) {
        this.searchObject.isCDSearch = value;
    }

    public getIsCDSearch() {
        return this.searchObject.isCDSearch;
    }

    public getLastViewedOffset() {
        return this.lastViewedOffset;
    }

    public setOffsetLimitNotificationVisible(visibleNow: boolean, visibleAfterSearch: boolean = false) {
        this.offsetLimitNotificationVisible = visibleNow;
        this.offsetLimitNotificationVisibleAfterSearch = visibleAfterSearch;
    }

    public isOffsetLimitNotificationVisible() {
        return this.offsetLimitNotificationVisible;
    }
}





// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchState.service.ts